.expander {
  width: 100%;
  min-width: 100%;
  display: block;
}

.expander-header, .expander-footer {
  user-select: none;
}

.expander-content {
  overflow: hidden;
  height: auto;
}


.expander-content-closed {
  transition: height 250ms linear 0ms;
}

.expander-content-open {
  transition: height 250ms linear 0ms;
}